<div #swiperContainer class="swiper" [ngClass]="cssClass ? cssClass : ''" >
  <div class="swiper-wrapper">
    <ng-content></ng-content>
  </div>
 
  <div class="my-swiper-pagination"></div>

  <ng-container *ngIf="navigation">
    <div class="my-swiper-next bottom"><i class="fas fa-chevron-right"></i></div>
    <div class="my-swiper-prev top"><i class="fas fa-chevron-left"></i></div>
  </ng-container>
</div>
